





































import { defineComponent, reactive, } from '@vue/composition-api'

declare interface timeLimitationItem {
  text: string;
  value: number;
}

export default defineComponent({
  
  setup(props, context) {

    const state = reactive<{
      timeLimitation: number,
      timeLimitationItems: timeLimitationItem[];
    }>({
      timeLimitation: 0,
      timeLimitationItems: [
          {
            text: 'Infinite',
            value: 0,
          },
          {
            text: '1',
            value: 1,
          },
          {
            text: '2',
            value: 2,
          },
          {
            text: '3',
            value: 3,
          },
          {
            text: '4',
            value: 4,
          },
          {
            text: '5',
            value: 5,
          }, 
          {
            text: '6',
            value: 6,
          },
          {
            text: '7',
            value: 7,
          },
          {
            text: '8',
            value: 8,
          },
          {
            text: '9',
            value: 9,
          },
          {
            text: '10',
            value: 10,
          },          
        ],
    })

    function setTimeLimitation(): void {
      context.emit('setTimeLimitation', state.timeLimitation)
    }

    function cancel(): void {
      context.emit('cancel')
    }

    return {
      state,
      setTimeLimitation,
      cancel,
    }
  }
})
